import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=2b5aa082&scoped=true"
import script from "./Register.js?vue&type=script&lang=js&external"
export * from "./Register.js?vue&type=script&lang=js&external"
import style0 from "./Register.scss?vue&type=style&index=0&id=2b5aa082&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5aa082",
  null
  
)

export default component.exports